import { faAngleRight } from '@fortawesome/pro-light-svg-icons/faAngleRight';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import noPhoto from '@propertypal/shared/src/resources/fallbacks/no-photo-icon.png';
import { Property } from '@propertypal/shared/src/types/property';
import { getMainImage } from '@propertypal/shared/src/utils/property';
import startCase from 'lodash/startCase';
import Link from 'next/link';
import React, { FunctionComponent } from 'react';
import { useTheme } from 'styled-components';
import PropertyBadge from '../property/PropertyBadge';
import PropertyPrice from '../property/PropertyPrice';
import { Text } from '../typography';
import {
  Address,
  Badge,
  BoxContent,
  Container,
  Box,
  PriceContainer,
  TopHalf,
  View,
  Arrow,
} from './RecentPropertyBox.style';

interface Props {
  property: Property;
  isLarge: boolean;
}

const RecentPropertiesHome: FunctionComponent<Props> = (props) => {
  const theme = useTheme();
  const { property, isLarge } = props;
  const [heroImage] = getMainImage(property);
  const displayAddress = `${property.addressLine1 ? `${property.addressLine1},` : ``} ${property.town}`;

  const noImage = !heroImage;

  return (
    <Container isLarge={isLarge}>
      <Link href={property.path}>
        <Box bgImage={heroImage || noPhoto.src} noImage={noImage} isLarge={isLarge}>
          <BoxContent>
            <TopHalf>
              <Address>
                <Text fontSize={20} fontWeight="bold" color={theme.white}>
                  {startCase(displayAddress.toLowerCase())}
                </Text>
              </Address>
              <PriceContainer>
                <PropertyPrice
                  price={property.price}
                  alternativeCurrencyPrice={property.alternativeCurrencyPrice}
                  fontSize={16}
                  color={theme.white}
                />
              </PriceContainer>
              <Badge>
                <PropertyBadge containerStyle={{ position: 'initial' }} property={property} />
              </Badge>
            </TopHalf>
            <View>
              <Text fontSize={16} color={theme.white}>
                View Property
              </Text>
              <Arrow>
                <FontAwesomeIcon icon={faAngleRight} color={theme.white} style={{ fontSize: 22 }} />
              </Arrow>
            </View>
          </BoxContent>
        </Box>
      </Link>
    </Container>
  );
};

export default RecentPropertiesHome;
